// extracted by mini-css-extract-plugin
export default {"container":"hangman_container__2yaVh","keyboard":"hangman_keyboard__W6vuy"};